import { faMinusCircle, faUsers } from '@fortawesome/pro-regular-svg-icons';
import { List, Row } from 'antd';
import React, { useState } from 'react';
import { AddRemoveContent, ColumnHeader, ContentItem, RoleGroupRow } from '../../../components';
import { AmplitudeEventsUtils } from '../../../utilities';
var ManageGroups = function (props) {
    var _a;
    var activeGroup = (_a = props === null || props === void 0 ? void 0 : props.groupsData) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.activeGroupIndex];
    var updateActivegroupIndex = function (index) {
        if (props.onGroupIndexUpdate) {
            props.onGroupIndexUpdate(index);
        }
    };
    var addGroup = function (groupName) {
        if (props.handleGroupAddition)
            props.handleGroupAddition(groupName);
    };
    var deleteGroup = function () {
        AmplitudeEventsUtils.manageGroupDeleteGroup(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name);
        if (props.handleGroupDeletion)
            props.handleGroupDeletion(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.id);
    };
    return React.createElement(Groups, { addgroup: addGroup, groupsData: props.groupsData, activegroupIndex: props.activeGroupIndex, updategroupIndex: updateActivegroupIndex, isMobileView: props.isMobileView, handleDeleteGroup: deleteGroup, updateGroupName: props.handleGroupRename, isViewOnly: props.isViewOnly, activeGroup: activeGroup });
};
export default ManageGroups;
var Groups = function (_a) {
    var groupsData = _a.groupsData, activegroupIndex = _a.activegroupIndex, updategroupIndex = _a.updategroupIndex, addgroup = _a.addgroup, isMobileView = _a.isMobileView, handleDeleteGroup = _a.handleDeleteGroup, updateGroupName = _a.updateGroupName, isViewOnly = _a.isViewOnly, activeGroup = _a.activeGroup;
    var _b = useState(-1), editableIndex = _b[0], updateEditableIndex = _b[1];
    var onRowEditToggle = function (index, state) {
        if (state)
            updateEditableIndex(index);
        else
            updateEditableIndex(-1);
    };
    var updateIndexOnRowChange = function (index) {
        if (activegroupIndex !== index)
            updateEditableIndex(-1);
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(ColumnHeader, { icon: faUsers, label: "Support groups", isMobileView: isMobileView })),
        !isViewOnly && React.createElement(Row, { style: isMobileView ? { minHeight: "60px" } : { minHeight: "130px" } },
            React.createElement(AddRemoveContent, { addContentNode: {
                    node: React.createElement(ContentItem, { description: "Add new group", disabled: isViewOnly }),
                    callback: function () { updateEditableIndex(-1); addgroup(); },
                    disabled: isViewOnly
                }, deleteContentNode: {
                    node: React.createElement(ContentItem, { disabled: isViewOnly || !(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name), color: "pink", iconName: faMinusCircle, description: "Delete selected group", subText: "Users are ungrouped and remain active" }),
                    callback: function () { updateEditableIndex(-1); handleDeleteGroup(); },
                    deleteConfirmation: true,
                    disabled: isViewOnly || !(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name)
                } })),
        React.createElement(Row, null,
            React.createElement(List, { itemLayout: "vertical", className: "managegrprls-items-list grp-names padding-right-xl", id: "grp-cntnr-list", style: { overflowX: "hidden" } }, groupsData && groupsData.map(function (group, index) { return (React.createElement(List.Item, { id: "grp-".concat(group === null || group === void 0 ? void 0 : group.id), key: index, onClick: function () { updategroupIndex(index); updateIndexOnRowChange(index); }, style: { border: isMobileView ? undefined : 0, padding: (index === editableIndex && index === activegroupIndex) ? "4px 8px" : "8px", cursor: "pointer" }, className: !isMobileView ? (index === activegroupIndex) ? "role-selected" : "" : "user-role-item" },
                React.createElement(RoleGroupRow, { isViewOnly: isViewOnly, row: group, rowIndex: index, onEditToggle: onRowEditToggle, isEditable: index === editableIndex, isSelected: index === activegroupIndex, updateName: updateGroupName }))); }))));
};
//# sourceMappingURL=index.js.map